var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-toolbar',{attrs:{"flat":"","absolute":"","color":"transparent"}},[_c('v-spacer'),_vm._v(" "),_c('a',{staticStyle:{"text-decoration":"none","font-family":"Montserrat, sans-serif","color":"white"},attrs:{"href":"https://universidadeparavida.com.br/contato/"}},[_vm._v("Contato")])],1),_vm._v(" "),_c('Home')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0146441a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 